import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import Preloading from "../../../components/basics/Preloading";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";
import Paginations from "../../../components/paginaton/Paginations";

const BaseInfoUnitMeasurements = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectId, setSelectId] = useState("");
  const [measurementDimensionTypes, setMeasurementDimensionTypes] = useState(
    []
  );
  const [girdData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    restaurantId: restaurantId,
    title: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    shortName: "",
    measurementDimensionType: 0,
    description: "",
    enabled: true,
    branchId: null,
    restaurantId: restaurantId,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    const resp = await apiMethod.getRestaurantUnitMeasurements(
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) return false;
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getMeasurementDimensionTypes();
    if (!methods.showApiErrors(resp1)) return false;
    setMeasurementDimensionTypes(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [restaurantId]);

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (
      methods.isNullOrEmptyString(formModel.restaurantId) ||
      formModel.restaurantId === 0
    ) {
      errors.push(".شناسه شعبه باید مقدار داشته باشد");
    }
    if (
      methods.isNullOrEmptyString(formModel.measurementDimensionType) ||
      formModel.measurementDimensionType === 0
    ) {
      errors.push(".نوع واحد سنجش باید مقدار داشته باشد");
    }
    if (methods.isNullOrEmptyString(formModel.shortName)) {
      errors.push("نام اختصار باید مقدار داشته باشد.");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.measurementDimensionType = 0;
    formModel.description = "";
    formModel.enabled = true;
    formModel.shortName = "";
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.restaurantId = restaurantId;
    filterModel.title = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getUnitMeasurementInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.shortName = resp.data.shortName;
    formModel.measurementDimensionType = resp.data.measurementDimensionType;
    formModel.description = resp.data.description;
    formModel.enabled = resp.data.enabled;
    formModel.restaurantId = resp.data.restaurantId;
    setFormModel({ ...formModel });
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm()) return false;

    setLoading(true);
    const resp = await apiMethod.createRestaurantUnitMeasurement(formModel);
    if (!methods.showApiErrors(resp)) return false;

    await getGridData();
    resetForm();
    setLoading(false);
    return true;
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeUnitMeasurement(selectId.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const getmeasurementDimensionName = (id) => {
    const item = measurementDimensionTypes.find((x) => x.id === id);
    if (item != null || item != undefined) return item.title;
    return "...";
  };

  const searchItem = async () => {
    setLoading(true);
    filterModel.title = document.getElementById("searchInput").value;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const copyItem = (item) => {
    console.log(item);
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.enabled = item.enabled;
    formModel.measurementDimensionType = item.measurementDimensionType;
    formModel.shortName = item.shortName;

    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderProductCategory = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/baseinfo/restaurant/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <Link to={`/baseinfo/${restaurantId}`} className="link back-link">
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                واحد های سنجش
              </Link>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                واحد های سنجش کالا
                <a
                  href={`/sale/${restaurantId}/softwareGuide/#section2`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-4">
                <span className="fw-bold fs-5">
                  افزودن / ویرایش واحد سنجش کالا
                </span>
              </div>
              <div className="row align-items-end g-3">
                <div className="col-12 col-md-3">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="title"
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({ ...formModel, title: e.target.value });
                    }}
                    placeholder="عنوان را بنویسید..."
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label
                    htmlFor="shortName"
                    className="form-label required-label"
                  >
                    نام اختصار
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="shortName"
                    value={formModel.shortName}
                    onChange={(e) => {
                      setFormModel({ ...formModel, shortName: e.target.value });
                    }}
                    placeholder="نام اختصار را بنویسید..."
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label
                    htmlFor="pricingType"
                    className="form-label required-label"
                  >
                    نوع واحد سنجش
                  </label>
                  <select
                    id="pricingType"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.measurementDimensionType}
                    onChange={(e) => {
                      formModel.measurementDimensionType = parseInt(
                        e.target.value
                      );
                      setFormModel({
                        ...formModel,
                        measurementDimensionType:
                          formModel.measurementDimensionType,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {measurementDimensionTypes.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <div className="form-check mt-2 mb-2">
                    <input
                      onChange={(e) => {
                        setFormModel({
                          ...formModel,
                          enabled: e.target.checked,
                        });
                      }}
                      checked={formModel.enabled}
                      className="form-check-input"
                      type="checkbox"
                      id="chbenabled"
                    />
                    <label className="form-check-label" htmlFor="chbenabled">
                      فعال
                    </label>
                  </div>
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control input-textarea"
                    id="description"
                    name="description"
                    rows={3}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                    placeholder="توضیحات را بنویسید..."
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple "
                  onClick={() => {
                    resetForm();
                  }}
                >
                  انصراف
                </button>
                <button
                  onClick={() => {
                    createNewItem();
                  }}
                  type="button"
                  className="btn custome-btn btn-purple"
                >
                  ثبت وذخیره
                </button>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-12 col-md-3">
                  <label htmlFor="funit" className="form-label">
                    عنوان
                  </label>
                  <input
                    id="searchInput"
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={filterModel.title}
                    onChange={(e) => {
                      e.target.value = e.target.value.trim();
                      filterModel.title = e.target.value;
                      setFilterModel({ ...filterModel });
                    }}
                    placeholder="جستجو کنید..."
                  />
                </div>
                <div className="col-12 col-md-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                واحد سنجش کالا
              </span>
              <div className="table-responsive baseinfoTable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">اختصار</th>
                      <th scope="col vertical-center">نوع واحد </th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">وضعیت</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {girdData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.shortName}</td>
                        <td>
                          {getmeasurementDimensionName(
                            item.measurementDimensionType
                          )}
                        </td>
                        <td>{item.description}</td>
                        <td>
                          {item.enabled ? (
                            <i className="bi bi-check-square fs-5 activeCheckbox"></i>
                          ) : (
                            <i className="bi bi-x-square fs-5 inActiveCheckbox"></i>
                          )}
                        </td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            className="button-action copy-btn"
                            onClick={() => copyItem(item)}
                          >
                            <img src={copy} alt="Copy" />
                          </button>
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {renderProductCategory()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={"واحد"}
        />
      )}
    </>
  );
};

export default BaseInfoUnitMeasurements;
